import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IntersectionObservableService {
  createIntersectionObservable(el: Element, options: IntersectionObserverInit) {
    return new Observable<IntersectionObserverEntry[]>((observer) => {
      const intersectionObserver = new IntersectionObserver((entries) => {
        observer.next(entries);
      }, options);
      intersectionObserver.observe(el);
      return function unsubscribe() {
        intersectionObserver.unobserve(el);
      };
    });
  }
}
